import * as React from 'react';
import NuiLoginRobotax from './nuiLoginRobotax';
import NuiAdminConsoleTabs from './nuiAdminConsoleTabs';

export default class NuiAdminConsole extends React.Component {
  checkLogin = document.getElementById('checkLogin').innerHTML === 'true';
  accessLevel = document.getElementById('accessLevel').innerHTML;

  constructor(props) {
    super(props);
  }

  render() {
    return this.checkLogin && this.accessLevel === 'admin'
      ? <NuiAdminConsoleTabs/>
      : <NuiLoginRobotax callback={function() {window.location.reload();}}/>;
  }
}
